import { useNavigation } from 'expo-router'
import { useEffect } from 'react'
import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import OrganizationInfoCard from '@/components/organization/cards/OrganizationInfoCard'
import OrganizationMedicalInfoCard from '@/components/organization/cards/OrganizationMedicalInfoCard'
import OrganizationReportsCard from '@/components/organization/cards/OrganizationReportsCard'
import OrganizationSubscriptionCard from '@/components/organization/cards/OrganizationSubscriptionCard'
import OrganizationVaccinesCard from '@/components/organization/cards/OrganizationVaccinesCard'
import Page from '@/components/shared/Page'
import { useAppStore } from '@/store/useAppStore'

const OrganizationSettings = () => {
  const navigation = useNavigation()

  const currentOrganization = useAppStore.use.currentOrganization().organization

  useEffect(() => {
    if (!currentOrganization?.name) {
      return
    }

    navigation.setOptions({
      title: currentOrganization?.name,
    })
  }, [currentOrganization?.name, navigation])

  return (
    <Page requiresSubscription={false} viewId="organization-settings">
      <OrganizationSubscriptionCard />
      <OrganizationReportsCard
        disabled={!currentOrganization?.subscriptionActive}
      />
      <OrganizationInfoCard
        disabled={!currentOrganization?.subscriptionActive}
      />
      <View style={styles.medicalContainer}>
        <OrganizationVaccinesCard
          disabled={!currentOrganization?.subscriptionActive}
        />
        <OrganizationMedicalInfoCard
          disabled={!currentOrganization?.subscriptionActive}
        />
      </View>
    </Page>
  )
}

const styles = StyleSheet.create((theme) => {
  return {
    medicalContainer: {
      alignItems: 'stretch',
      flexDirection: {
        md: 'column',
        lg: 'row',
      },
      gap: theme.tokens.spacing[4],
    },
  }
})

export default OrganizationSettings
